module.exports = __webpack_public_path__ + "img/img9.192f715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img9.jpg
// module id = 304
// module chunks = 0